/**
 * 案由列表常量
 * 包含民事、刑事、行政等各类完整案由
 */

export const CASE_REASONS = [
  // ==================== 人格权纠纷 ====================
  '人格权纠纷',
  '生命权、身体权、健康权纠纷',
  '姓名权纠纷',
  '名称权纠纷',
  '肖像权纠纷',
  '声音保护纠纷',
  '名誉权纠纷',
  '荣誉权纠纷',
  '隐私权、个人信息保护纠纷',
  '隐私权纠纷',
  '个人信息保护纠纷',
  '婚姻自主权纠纷',
  '人身自由权纠纷',
  '一般人格权纠纷',
  '平等就业权纠纷',

  // ==================== 婚姻家庭、继承纠纷 ====================
  '婚姻家庭、继承纠纷',
  '婚姻家庭纠纷',
  '婚约财产纠纷',
  '婚内夫妻财产分割纠纷',
  '离婚纠纷',
  '离婚后财产纠纷',
  '离婚后损害责任纠纷',
  '婚姻无效纠纷',
  '撤销婚姻纠纷',
  '夫妻财产约定纠纷',
  '同居关系纠纷',
  '同居关系析产纠纷',
  '同居关系子女抚养纠纷',
  '亲子关系纠纷',
  '确认亲子关系纠纷',
  '否认亲子关系纠纷',
  '抚养纠纷',
  '抚养费纠纷',
  '变更抚养关系纠纷',
  '扶养纠纷',
  '扶养费纠纷',
  '变更扶养关系纠纷',
  '赡养纠纷',
  '赡养费纠纷',
  '变更赡养关系纠纷',
  '收养关系纠纷',
  '确认收养关系纠纷',
  '解除收养关系纠纷',
  '监护权纠纷',
  '探望权纠纷',
  '分家析产纠纷',
  '继承纠纷',
  '法定继承纠纷',
  '转继承纠纷',
  '代位继承纠纷',
  '遗嘱继承纠纷',
  '被继承人债务清偿纠纷',
  '遗赠纠纷',
  '遗赠扶养协议纠纷',
  '遗产管理纠纷',

  // ==================== 物权纠纷 ====================
  '物权纠纷',
  '不动产登记纠纷',
  '异议登记不当损害责任纠纷',
  '虚假登记损害责任纠纷',
  '物权保护纠纷',
  '物权确认纠纷',
  '所有权确认纠纷',
  '用益物权确认纠纷',
  '担保物权确认纠纷',
  '返还原物纠纷',
  '排除妨害纠纷',
  '消除危险纠纷',
  '修理、重作、更换纠纷',
  '恢复原状纠纷',
  '财产损害赔偿纠纷',
  '所有权纠纷',
  '侵害集体经济组织成员权益纠纷',
  '建筑物区分所有权纠纷',
  '业主专有权纠纷',
  '业主共有权纠纷',
  '车位纠纷',
  '车库纠纷',
  '业主撤销权纠纷',
  '业主知情权纠纷',
  '遗失物返还纠纷',
  '漂流物返还纠纷',
  '埋藏物返还纠纷',
  '隐藏物返还纠纷',
  '添附物归属纠纷',
  '相邻关系纠纷',
  '相邻用水、排水纠纷',
  '相邻通行纠纷',
  '相邻土地、建筑物利用关系纠纷',
  '相邻通风纠纷',
  '相邻采光、日照纠纷',
  '相邻污染侵害纠纷',
  '相邻损害防免关系纠纷',
  '共有纠纷',
  '共有权确认纠纷',
  '共有物分割纠纷',
  '共有人优先购买权纠纷',
  '债权人代位析产纠纷',
  '用益物权纠纷',
  '海域使用权纠纷',
  '探矿权纠纷',
  '采矿权纠纷',
  '取水权纠纷',
  '养殖权纠纷',
  '捕捞权纠纷',
  '土地承包经营权纠纷',
  '土地承包经营权确认纠纷',
  '承包地征收补偿费用分配纠纷',
  '土地承包经营权继承纠纷',
  '土地经营权纠纷',
  '建设用地使用权纠纷',
  '宅基地使用权纠纷',
  '居住权纠纷',
  '地役权纠纷',
  '担保物权纠纷',
  '抵押权纠纷',
  '建筑物和其他土地附着物抵押权纠纷',
  '在建建筑物抵押权纠纷',
  '建设用地使用权抵押权纠纷',
  '土地经营权抵押权纠纷',
  '探矿权抵押权纠纷',
  '采矿权抵押权纠纷',
  '海域使用权抵押权纠纷',
  '动产抵押权纠纷',
  '在建船舶、航空器抵押权纠纷',
  '动产浮动抵押权纠纷',
  '最高额抵押权纠纷',
  '质权纠纷',
  '动产质权纠纷',
  '转质权纠纷',
  '最高额质权纠纷',
  '票据质权纠纷',
  '债券质权纠纷',
  '存单质权纠纷',
  '仓单质权纠纷',
  '提单质权纠纷',
  '股权质权纠纷',
  '基金份额质权纠纷',
  '知识产权质权纠纷',
  '应收账款质权纠纷',
  '留置权纠纷',
  '占有保护纠纷',
  '占有物返还纠纷',
  '占有排除妨害纠纷',
  '占有消除危险纠纷',
  '占有物损害赔偿纠纷',

  // ==================== 合同、准合同纠纷 ====================
  '合同、准合同纠纷',
  '合同纠纷',
  '劳务合同纠纷',
  '缔约过失责任纠纷',
  '预约合同纠纷',
  '确认合同效力纠纷',
  '确认合同有效纠纷',
  '确认合同无效纠纷',
  '债权人代位权纠纷',
  '债权人撤销权纠纷',
  '债权转让合同纠纷',
  '债务转移合同纠纷',
  '债权债务概括转移合同纠纷',
  '债务加入纠纷',
  '悬赏广告纠纷',
  '买卖合同纠纷',
  '分期付款买卖合同纠纷',
  '凭样品买卖合同纠纷',
  '试用买卖合同纠纷',
  '所有权保留买卖合同纠纷',
  '招标投标买卖合同纠纷',
  '互易纠纷',
  '国际货物买卖合同纠纷',
  '信息网络买卖合同纠纷',
  '拍卖合同纠纷',
  '建设用地使用权合同纠纷',
  '建设用地使用权出让合同纠纷',
  '建设用地使用权转让合同纠纷',
  '临时用地合同纠纷',
  '探矿权转让合同纠纷',
  '采矿权转让合同纠纷',
  '房地产开发经营合同纠纷',
  '委托代建合同纠纷',
  '合资、合作开发房地产合同纠纷',
  '项目转让合同纠纷',
  '房屋买卖合同纠纷',
  '商品房预约合同纠纷',
  '商品房预售合同纠纷',
  '商品房销售合同纠纷',
  '商品房委托代理销售合同纠纷',
  '经济适用房转让合同纠纷',
  '农村房屋买卖合同纠纷',
  '民事主体间房屋拆迁补偿合同纠纷',
  '供用电合同纠纷',
  '供用水合同纠纷',
  '供用气合同纠纷',
  '供用热力合同纠纷',
  '排污权交易纠纷',
  '用能权交易纠纷',
  '用水权交易纠纷',
  '碳排放权交易纠纷',
  '碳汇交易纠纷',
  '赠与合同纠纷',
  '公益事业捐赠合同纠纷',
  '附义务赠与合同纠纷',
  '借款合同纠纷',
  '金融借款合同纠纷',
  '同业拆借纠纷',
  '民间借贷纠纷',
  '小额借款合同纠纷',
  '金融不良债权转让合同纠纷',
  '金融不良债权追偿纠纷',
  '保证合同纠纷',
  '抵押合同纠纷',
  '质押合同纠纷',
  '定金合同纠纷',
  '进出口押汇纠纷',
  '储蓄存款合同纠纷',
  '银行卡纠纷',
  '借记卡纠纷',
  '信用卡纠纷',
  '租赁合同纠纷',
  '土地租赁合同纠纷',
  '房屋租赁合同纠纷',
  '车辆租赁合同纠纷',
  '建筑设备租赁合同纠纷',
  '融资租赁合同纠纷',
  '保理合同纠纷',
  '承揽合同纠纷',
  '加工合同纠纷',
  '定作合同纠纷',
  '修理合同纠纷',
  '复制合同纠纷',
  '测试合同纠纷',
  '检验合同纠纷',
  '铁路机车、车辆建造合同纠纷',
  '建设工程合同纠纷',
  '建设工程勘察合同纠纷',
  '建设工程设计合同纠纷',
  '建设工程施工合同纠纷',
  '建设工程价款优先受偿权纠纷',
  '建设工程分包合同纠纷',
  '建设工程监理合同纠纷',
  '装饰装修合同纠纷',
  '铁路修建合同纠纷',
  '农村建房施工合同纠纷',
  '运输合同纠纷',
  '公路旅客运输合同纠纷',
  '公路货物运输合同纠纷',
  '水路旅客运输合同纠纷',
  '水路货物运输合同纠纷',
  '航空旅客运输合同纠纷',
  '航空货物运输合同纠纷',
  '出租汽车运输合同纠纷',
  '管道运输合同纠纷',
  '城市公交运输合同纠纷',
  '联合运输合同纠纷',
  '多式联运合同纠纷',
  '铁路货物运输合同纠纷',
  '铁路旅客运输合同纠纷',
  '铁路行李运输合同纠纷',
  '铁路包裹运输合同纠纷',
  '国际铁路联运合同纠纷',
  '保管合同纠纷',
  '仓储合同纠纷',
  '委托合同纠纷',
  '进出口代理合同纠纷',
  '货运代理合同纠纷',
  '民用航空运输销售代理合同纠纷',
  '诉讼、仲裁、人民调解代理合同纠纷',
  '销售代理合同纠纷',
  '委托理财合同纠纷',
  '金融委托理财合同纠纷',
  '民间委托理财合同纠纷',
  '物业服务合同纠纷',
  '行纪合同纠纷',
  '中介合同纠纷',
  '补偿贸易纠纷',
  '借用合同纠纷',
  '典当纠纷',
  '合伙合同纠纷',
  '种植、养殖回收合同纠纷',
  '彩票、奖券纠纷',
  '中外合作勘探开发自然资源合同纠纷',
  '农业承包合同纠纷',
  '林业承包合同纠纷',
  '渔业承包合同纠纷',
  '牧业承包合同纠纷',
  '土地承包经营权合同纠纷',
  '土地承包经营权转让合同纠纷',
  '土地承包经营权互换合同纠纷',
  '土地经营权入股合同纠纷',
  '土地经营权抵押合同纠纷',
  '土地经营权出租合同纠纷',
  '居住权合同纠纷',
  '服务合同纠纷',
  '电信服务合同纠纷',
  '邮政服务合同纠纷',
  '快递服务合同纠纷',
  '医疗服务合同纠纷',
  '法律服务合同纠纷',
  '旅游合同纠纷',
  '房地产咨询合同纠纷',
  '房地产价格评估合同纠纷',
  '旅店服务合同纠纷',
  '财会服务合同纠纷',
  '餐饮服务合同纠纷',
  '娱乐服务合同纠纷',
  '有线电视服务合同纠纷',
  '网络服务合同纠纷',
  '教育培训合同纠纷',
  '家政服务合同纠纷',
  '庆典服务合同纠纷',
  '殡葬服务合同纠纷',
  '农业技术服务合同纠纷',
  '农机作业服务合同纠纷',
  '保安服务合同纠纷',
  '银行结算合同纠纷',
  '演出合同纠纷',
  '离退休人员返聘合同纠纷',
  '广告合同纠纷',
  '展览合同纠纷',
  '追偿权纠纷',
  '不当得利纠纷',
  '无因管理纠纷',

  // ==================== 知识产权与竞争纠纷 ====================
  '知识产权与竞争纠纷',
  '知识产权合同纠纷',
  '著作权合同纠纷',
  '委托创作合同纠纷',
  '合作创作合同纠纷',
  '著作权转让合同纠纷',
  '著作权许可使用合同纠纷',
  '出版合同纠纷',
  '表演合同纠纷',
  '音像制品制作合同纠纷',
  '广播电视播放合同纠纷',
  '邻接权转让合同纠纷',
  '邻接权许可使用合同纠纷',
  '计算机软件开发合同纠纷',
  '计算机软件著作权转让合同纠纷',
  '计算机软件著作权许可使用合同纠纷',
  '商标合同纠纷',
  '商标权转让合同纠纷',
  '商标使用许可合同纠纷',
  '商标代理合同纠纷',
  '专利合同纠纷',
  '专利申请权转让合同纠纷',
  '专利权转让合同纠纷',
  '发明专利实施许可合同纠纷',
  '实用新型专利实施许可合同纠纷',
  '外观设计专利实施许可合同纠纷',
  '专利代理合同纠纷',
  '植物新品种合同纠纷',
  '植物新品种育种合同纠纷',
  '植物新品种申请权转让合同纠纷',
  '植物新品种权转让合同纠纷',
  '植物新品种实施许可合同纠纷',
  '集成电路布图设计合同纠纷',
  '集成电路布图设计创作合同纠纷',
  '集成电路布图设计专有权转让合同纠纷',
  '集成电路布图设计许可使用合同纠纷',
  '商业秘密合同纠纷',
  '技术秘密让与合同纠纷',
  '技术秘密许可使用合同纠纷',
  '经营秘密让与合同纠纷',
  '经营秘密许可使用合同纠纷',
  '技术合同纠纷',
  '技术委托开发合同纠纷',
  '技术合作开发合同纠纷',
  '技术转化合同纠纷',
  '技术转让合同纠纷',
  '技术许可合同纠纷',
  '技术咨询合同纠纷',
  '技术服务合同纠纷',
  '技术培训合同纠纷',
  '技术中介合同纠纷',
  '技术进口合同纠纷',
  '技术出口合同纠纷',
  '职务技术成果完成人奖励、报酬纠纷',
  '技术成果完成人署名权、荣誉权、奖励权纠纷',
  '特许经营合同纠纷',
  '企业名称（商号）合同纠纷',
  '企业名称（商号）转让合同纠纷',
  '企业名称（商号）使用合同纠纷',
  '特殊标志合同纠纷',
  '网络域名合同纠纷',
  '网络域名注册合同纠纷',
  '网络域名转让合同纠纷',
  '网络域名许可使用合同纠纷',
  '知识产权质押合同纠纷',
  '知识产权权属、侵权纠纷',
  '著作权权属、侵权纠纷',
  '著作权权属纠纷',
  '侵害作品发表权纠纷',
  '侵害作品署名权纠纷',
  '侵害作品修改权纠纷',
  '侵害保护作品完整权纠纷',
  '侵害作品复制权纠纷',
  '侵害作品发行权纠纷',
  '侵害作品出租权纠纷',
  '侵害作品展览权纠纷',
  '侵害作品表演权纠纷',
  '侵害作品放映权纠纷',
  '侵害作品广播权纠纷',
  '侵害作品信息网络传播权纠纷',
  '侵害作品摄制权纠纷',
  '侵害作品改编权纠纷',
  '侵害作品翻译权纠纷',
  '侵害作品汇编权纠纷',
  '侵害其他著作财产权纠纷',
  '出版者权权属纠纷',
  '表演者权权属纠纷',
  '录音录像制作者权权属纠纷',
  '广播组织权权属纠纷',
  '侵害出版者权纠纷',
  '侵害表演者权纠纷',
  '侵害录音录像制作者权纠纷',
  '侵害广播组织权纠纷',
  '计算机软件著作权权属纠纷',
  '侵害计算机软件著作权纠纷',
  '商标权权属、侵权纠纷',
  '商标权权属纠纷',
  '侵害商标权纠纷',
  '专利权权属、侵权纠纷',
  '专利申请权权属纠纷',
  '专利权权属纠纷',
  '侵害发明专利权纠纷',
  '侵害实用新型专利权纠纷',
  '侵害外观设计专利权纠纷',
  '假冒他人专利纠纷',
  '发明专利临时保护期使用费纠纷',
  '职务发明创造发明人、设计人奖励、报酬纠纷',
  '发明创造发明人、设计人署名权纠纷',
  '标准必要专利使用费纠纷',
  '植物新品种权权属、侵权纠纷',
  '植物新品种申请权权属纠纷',
  '植物新品种权权属纠纷',
  '侵害植物新品种权纠纷',
  '植物新品种临时保护期使用费纠纷',
  '集成电路布图设计专有权权属、侵权纠纷',
  '集成电路布图设计专有权权属纠纷',
  '侵害集成电路布图设计专有权纠纷',
  '侵害企业名称（商号）权纠纷',
  '侵害特殊标志专有权纠纷',
  '网络域名权属、侵权纠纷',
  '网络域名权属纠纷',
  '侵害网络域名纠纷',
  '发现权纠纷',
  '发明权纠纷',
  '其他科技成果权纠纷',
  '确认不侵害知识产权纠纷',
  '确认不侵害专利权纠纷',
  '确认不侵害商标权纠纷',
  '确认不侵害著作权纠纷',
  '确认不侵害植物新品种权纠纷',
  '确认不侵害集成电路布图设计专用权纠纷',
  '确认不侵害计算机软件著作权纠纷',
  '因申请知识产权临时措施损害责任纠纷',
  '因申请诉前停止侵害专利权损害责任纠纷',
  '因申请诉前停止侵害注册商标专用权损害责任纠纷',
  '因申请诉前停止侵害著作权损害责任纠纷',
  '因申请诉前停止侵害植物新品种权损害责任纠纷',
  '因申请海关知识产权保护措施损害责任纠纷',
  '因申请诉前停止侵害计算机软件著作权损害责任纠纷',
  '因申请诉前停止侵害集成电路布图设计专用权损害责任纠纷',
  '因恶意提起知识产权诉讼损害责任纠纷',
  '专利权宣告无效后返还费用纠纷',
  '不正当竞争纠纷',
  '仿冒纠纷',
  '擅自使用与他人有一定影响的商品名称、包装、装潢等相同或者近似的标识纠纷',
  '擅自使用他人有一定影响的企业名称、社会组织名称、姓名纠纷',
  '擅自使用他人有一定影响的域名主体部分、网站名称、网页纠纷',
  '商业贿赂不正当竞争纠纷',
  '虚假宣传纠纷',
  '侵害商业秘密纠纷',
  '侵害技术秘密纠纷',
  '侵害经营秘密纠纷',
  '低价倾销不正当竞争纠纷',
  '捆绑销售不正当竞争纠纷',
  '有奖销售纠纷',
  '商业诋毁纠纷',
  '串通投标不正当竞争纠纷',
  '网络不正当竞争纠纷',
  '垄断纠纷',
  '垄断协议纠纷',
  '横向垄断协议纠纷',
  '纵向垄断协议纠纷',
  '滥用市场支配地位纠纷',
  '垄断定价纠纷',
  '掠夺定价纠纷',
  '拒绝交易纠纷',
  '限定交易纠纷',
  '捆绑交易纠纷',
  '差别待遇纠纷',
  '经营者集中纠纷',

  // ==================== 劳动争议、人事争议 ====================
  '劳动争议、人事争议',
  '劳动争议',
  '劳动合同纠纷',
  '确认劳动关系纠纷',
  '集体合同纠纷',
  '劳务派遣合同纠纷',
  '非全日制用工纠纷',
  '追索劳动报酬纠纷',
  '经济补偿金纠纷',
  '竞业限制纠纷',
  '社会保险纠纷',
  '养老保险待遇纠纷',
  '工伤保险待遇纠纷',
  '医疗保险待遇纠纷',
  '生育保险待遇纠纷',
  '失业保险待遇纠纷',
  '福利待遇纠纷',
  '人事争议',
  '聘用合同纠纷',
  '聘任合同纠纷',
  '辞职纠纷',
  '辞退纠纷',

  // ==================== 海事海商纠纷 ====================
  '海事海商纠纷',
  '船舶碰撞损害责任纠纷',
  '船舶触碰损害责任纠纷',
  '船舶损坏空中设施、水下设施损害责任纠纷',
  '船舶污染损害责任纠纷',
  '海上、通海水域污染损害责任纠纷',
  '海上、通海水域养殖损害责任纠纷',
  '海上、通海水域财产损害责任纠纷',
  '海上、通海水域人身损害责任纠纷',
  '非法留置船舶、船载货物、船用燃油、船用物料损害责任纠纷',
  '海上、通海水域货物运输合同纠纷',
  '海上、通海水域旅客运输合同纠纷',
  '海上、通海水域行李运输合同纠纷',
  '船舶经营管理合同纠纷',
  '船舶买卖合同纠纷',
  '船舶建造合同纠纷',
  '船舶修理合同纠纷',
  '船舶改建合同纠纷',
  '船舶拆解合同纠纷',
  '船舶抵押合同纠纷',
  '航次租船合同纠纷',
  '船舶租用合同纠纷',
  '定期租船合同纠纷',
  '光船租赁合同纠纷',
  '船舶融资租赁合同纠纷',
  '海上、通海水域运输船舶承包合同纠纷',
  '渔船承包合同纠纷',
  '船舶属具租赁合同纠纷',
  '船舶属具保管合同纠纷',
  '海运集装箱租赁合同纠纷',
  '海运集装箱保管合同纠纷',
  '港口货物保管合同纠纷',
  '船舶代理合同纠纷',
  '海上、通海水域货运代理合同纠纷',
  '理货合同纠纷',
  '船舶物料和备品供应合同纠纷',
  '船员劳务合同纠纷',
  '海难救助合同纠纷',
  '海上、通海水域打捞合同纠纷',
  '海上、通海水域拖航合同纠纷',
  '海上、通海水域保险合同纠纷',
  '海上、通海水域保赔合同纠纷',
  '海上、通海水域运输联营合同纠纷',
  '船舶营运借款合同纠纷',
  '海事担保合同纠纷',
  '航道、港口疏浚合同纠纷',
  '船坞、码头建造合同纠纷',
  '船舶检验合同纠纷',
  '海事请求担保纠纷',
  '海上、通海水域运输重大责任事故责任纠纷',
  '港口作业重大责任事故责任纠纷',
  '港口作业纠纷',
  '共同海损纠纷',
  '海洋开发利用纠纷',
  '船舶共有纠纷',
  '船舶权属纠纷',
  '海运欺诈纠纷',
  '海事债权确权纠纷',

  // ==================== 与公司、证券、保险、票据等有关的民事纠纷 ====================
  '与公司、证券、保险、票据等有关的民事纠纷',
  '与企业有关的纠纷',
  '企业出资人权益确认纠纷',
  '侵害企业出资人权益纠纷',
  '企业公司制改造合同纠纷',
  '企业股份合作制改造合同纠纷',
  '企业债权转股权合同纠纷',
  '企业分立合同纠纷',
  '企业租赁经营合同纠纷',
  '企业出售合同纠纷',
  '挂靠经营合同纠纷',
  '企业兼并合同纠纷',
  '联营合同纠纷',
  '企业承包经营合同纠纷',
  '中外合资经营企业承包经营合同纠纷',
  '中外合作经营企业承包经营合同纠纷',
  '外商独资企业承包经营合同纠纷',
  '乡镇企业承包经营合同纠纷',
  '中外合资经营企业合同纠纷',
  '中外合作经营企业合同纠纷',
  '与公司有关的纠纷',
  '股东资格确认纠纷',
  '股东名册记载纠纷',
  '请求变更公司登记纠纷',
  '股东出资纠纷',
  '新增资本认购纠纷',
  '股东知情权纠纷',
  '请求公司收购股份纠纷',
  '股权转让纠纷',
  '公司决议纠纷',
  '公司决议效力确认纠纷',
  '公司决议撤销纠纷',
  '公司设立纠纷',
  '公司证照返还纠纷',
  '发起人责任纠纷',
  '公司盈余分配纠纷',
  '损害股东利益责任纠纷',
  '损害公司利益责任纠纷',
  '损害公司债权人利益责任纠纷',
  '股东损害公司债权人利益责任纠纷',
  '实际控制人损害公司债权人利益责任纠纷',
  '公司关联交易损害责任纠纷',
  '公司合并纠纷',
  '公司分立纠纷',
  '公司减资纠纷',
  '公司增资纠纷',
  '公司解散纠纷',
  '清算责任纠纷',
  '上市公司收购纠纷',
  '合伙企业纠纷',
  '入伙纠纷',
  '退伙纠纷',
  '合伙企业财产份额转让纠纷',
  '与破产有关的纠纷',
  '请求撤销个别清偿行为纠纷',
  '请求确认债务人行为无效纠纷',
  '对外追收债权纠纷',
  '追收未缴出资纠纷',
  '追收抽逃出资纠纷',
  '追收非正常收入纠纷',
  '破产债权确认纠纷',
  '职工破产债权确认纠纷',
  '普通破产债权确认纠纷',
  '取回权纠纷',
  '一般取回权纠纷',
  '出卖人取回权纠纷',
  '破产抵销权纠纷',
  '别除权纠纷',
  '破产撤销权纠纷',
  '损害债务人利益赔偿纠纷',
  '管理人责任纠纷',
  '证券纠纷',
  '证券权利确认纠纷',
  '股票权利确认纠纷',
  '公司债券权利确认纠纷',
  '国债权利确认纠纷',
  '证券投资基金权利确认纠纷',
  '证券交易合同纠纷',
  '股票交易纠纷',
  '公司债券交易纠纷',
  '国债交易纠纷',
  '证券投资基金交易纠纷',
  '金融衍生品种交易纠纷',
  '证券承销合同纠纷',
  '证券代销合同纠纷',
  '证券包销合同纠纷',
  '证券投资咨询纠纷',
  '证券资信评级服务合同纠纷',
  '证券回购合同纠纷',
  '股票回购合同纠纷',
  '国债回购合同纠纷',
  '公司债券回购合同纠纷',
  '证券投资基金回购合同纠纷',
  '质押式证券回购纠纷',
  '证券上市合同纠纷',
  '证券交易代理合同纠纷',
  '证券上市保荐合同纠纷',
  '证券发行纠纷',
  '证券认购纠纷',
  '证券发行失败纠纷',
  '证券返还纠纷',
  '证券欺诈责任纠纷',
  '证券内幕交易责任纠纷',
  '操纵证券交易市场责任纠纷',
  '证券虚假陈述责任纠纷',
  '欺诈客户责任纠纷',
  '证券托管纠纷',
  '证券登记、存管、结算纠纷',
  '融资融券交易纠纷',
  '客户交易结算资金纠纷',
  '期货交易纠纷',
  '期货经纪合同纠纷',
  '期货透支交易纠纷',
  '期货强行平仓纠纷',
  '期货实物交割纠纷',
  '期货保证合约纠纷',
  '期货交易代理合同纠纷',
  '侵占期货交易保证金纠纷',
  '期货欺诈责任纠纷',
  '操纵期货交易市场责任纠纷',
  '期货内幕交易责任纠纷',
  '期货虚假信息责任纠纷',
  '信托纠纷',
  '民事信托纠纷',
  '营业信托纠纷',
  '公益信托纠纷',
  '保险纠纷',
  '财产保险合同纠纷',
  '财产损失保险合同纠纷',
  '责任保险合同纠纷',
  '信用保险合同纠纷',
  '保证保险合同纠纷',
  '保险人代位求偿权纠纷',
  '人身保险合同纠纷',
  '人寿保险合同纠纷',
  '意外伤害保险合同纠纷',
  '健康保险合同纠纷',
  '再保险合同纠纷',
  '保险经纪合同纠纷',
  '保险代理合同纠纷',
  '进出口信用保险合同纠纷',
  '保险费纠纷',
  '票据纠纷',
  '票据付款请求权纠纷',
  '票据追索权纠纷',
  '票据交付请求权纠纷',
  '票据返还请求权纠纷',
  '票据损害责任纠纷',
  '票据利益返还请求权纠纷',
  '汇票回单签发请求权纠纷',
  '票据保证纠纷',
  '确认票据无效纠纷',
  '票据代理纠纷',
  '票据回购纠纷',
  '信用证纠纷',
  '委托开立信用证纠纷',
  '信用证开证纠纷',
  '信用证议付纠纷',
  '信用证欺诈纠纷',
  '信用证融资纠纷',
  '信用证转让纠纷',
  '独立保函纠纷',
  '独立保函开立纠纷',
  '独立保函付款纠纷',
  '独立保函追偿纠纷',
  '独立保函欺诈纠纷',
  '独立保函转让纠纷',
  '独立保函通知纠纷',
  '独立保函撤销纠纷',

  // ==================== 侵权责任纠纷 ====================
  '侵权责任纠纷',
  '监护人责任纠纷',
  '用人单位责任纠纷',
  '劳务派遣工作人员侵权责任纠纷',
  '提供劳务者致害责任纠纷',
  '提供劳务者受害责任纠纷',
  '网络侵权责任纠纷',
  '网络侵害虚拟财产纠纷',
  '违反安全保障义务责任纠纷',
  '经营场所、公共场所的经营者、管理者责任纠纷',
  '群众性活动组织者责任纠纷',
  '教育机构责任纠纷',
  '性骚扰损害责任纠纷',
  '产品责任纠纷',
  '产品生产者责任纠纷',
  '产品销售者责任纠纷',
  '产品运输者责任纠纷',
  '产品仓储者责任纠纷',
  '机动车交通事故责任纠纷',
  '非机动车交通事故责任纠纷',
  '医疗损害责任纠纷',
  '侵害患者知情同意权责任纠纷',
  '医疗产品责任纠纷',
  '环境污染责任纠纷',
  '大气污染责任纠纷',
  '水污染责任纠纷',
  '土壤污染责任纠纷',
  '电子废物污染责任纠纷',
  '固体废物污染责任纠纷',
  '噪声污染责任纠纷',
  '光污染责任纠纷',
  '放射性污染责任纠纷',
  '生态破坏责任纠纷',
  '高度危险责任纠纷',
  '民用核设施、核材料损害责任纠纷',
  '民用航空器损害责任纠纷',
  '占有、使用高度危险物损害责任纠纷',
  '高度危险活动损害责任纠纷',
  '遗失、抛弃高度危险物损害责任纠纷',
  '非法占有高度危险物损害责任纠纷',
  '饲养动物损害责任纠纷',
  '建筑物和物件损害责任纠纷',
  '物件脱落、坠落损害责任纠纷',
  '建筑物、构筑物倒塌、塌陷损害责任纠纷',
  '高空抛物、坠物损害责任纠纷',
  '堆放物倒塌、滚落、滑落损害责任纠纷',
  '公共道路妨碍通行损害责任纠纷',
  '林木折断、倾倒、果实坠落损害责任纠纷',
  '地面施工、地下设施损害责任纠纷',
  '触电人身损害责任纠纷',
  '义务帮工人受害责任纠纷',
  '见义勇为人受害责任纠纷',
  '公证损害责任纠纷',
  '防卫过当损害责任纠纷',
  '紧急避险损害责任纠纷',
  '驻香港、澳门特别行政区军人执行职务侵权责任纠纷',
  '铁路运输损害责任纠纷',
  '铁路运输人身损害责任纠纷',
  '铁路运输财产损害责任纠纷',
  '水上运输损害责任纠纷',
  '水上运输人身损害责任纠纷',
  '水上运输财产损害责任纠纷',
  '航空运输损害责任纠纷',
  '航空运输人身损害责任纠纷',
  '航空运输财产损害责任纠纷',
  '因申请财产保全损害责任纠纷',
  '因申请行为保全损害责任纠纷',
  '因申请证据保全损害责任纠纷',
  '因申请先予执行损害责任纠纷',

  // ==================== 非讼程序案件案由 ====================
  '非讼程序案件案由',
  '选民资格案件',
  '申请确定选民资格',
  '宣告失踪、宣告死亡案件',
  '申请宣告自然人失踪',
  '申请撤销宣告失踪判决',
  '申请为失踪人财产指定、变更代管人',
  '申请宣告自然人死亡',
  '申请撤销宣告自然人死亡判决',
  '认定自然人无民事行为能力、限制民事行为能力案件',
  '申请宣告自然人无民事行为能力',
  '申请宣告自然人限制民事行为能力',
  '申请宣告自然人恢复限制民事行为能力',
  '申请宣告公民恢复完全民事行为能力',
  '指定遗产管理人案件',
  '申请指定遗产管理人',
  '认定财产无主案件',
  '申请认定财产无主',
  '申请撤销认定财产无主判决',
  '确认调解协议案件',
  '申请司法确认调解协议',
  '申请撤销确认调解协议裁定',
  '实现担保物权案件',
  '申请实现担保物权',
  '申请撤销准许实现担保物权裁定',
  '监护权特别程序案件',
  '申请确定监护人',
  '申请指定监护人',
  '申请变更监护人',
  '申请撤销监护人资格',
  '申请恢复监护人资格',
  '督促程序案件',
  '申请支付令',
  '公示催告程序案件',
  '申请公示催告',
  '公司清算案件',
  '申请公司清算',
  '破产程序案件',
  '申请破产清算',
  '申请破产重整',
  '申请破产和解',
  '申请对破产财产追加分配',
  '申请诉前停止侵害知识产权案件',
  '申请诉前停止侵害专利权',
  '申请诉前停止侵害注册商标专用权',
  '申请诉前停止侵害著作权',
  '申请诉前停止侵害植物新品种权',
  '申请诉前停止侵害计算机软件著作权',
  '申请诉前停止侵害集成电路布图设计专用权',
  '申请保全案件',
  '申请诉前财产保全',
  '申请诉前行为保全',
  '申请诉前证据保全',
  '申请仲裁前财产保全',
  '申请仲裁前行为保全',
  '申请仲裁前证据保全',
  '仲裁程序中的财产保全',
  '仲裁程序中的证据保全',
  '申请执行前财产保全',
  '申请中止支付信用证项下款项',
  '申请中止支付保函项下款项',
  '申请人身安全保护令案件',
  '申请人身安全保护令',
  '申请人格权侵害禁令案件',
  '申请人格权侵害禁令',
  '仲裁程序案件',
  '申请确认仲裁协议效力',
  '申请撤销仲裁裁决',
  '海事诉讼特别程序案件',
  '申请海事请求保全',
  '申请扣押船舶',
  '申请拍卖扣押船舶',
  '申请扣押船载货物',
  '申请拍卖扣押船载货物',
  '申请扣押船用燃油及船用物料',
  '申请拍卖扣押船用燃油及船用物料',
  '申请海事支付令',
  '申请海事强制令',
  '申请海事证据保全',
  '申请设立海事赔偿责任限制基金',
  '申请船舶优先权催告',
  '申请海事债权登记与受偿',
  '申请承认与执行法院判决、仲裁裁决案件',
  '申请执行海事仲裁裁决',
  '申请执行知识产权仲裁裁决',
  '申请执行涉外仲裁裁决',
  '申请认可和执行香港特别行政区法院民事判决',
  '申请认可和执行香港特别行政区仲裁裁决',
  '申请认可和执行澳门特别行政区法院民事判决',
  '申请认可和执行澳门特别行政区仲裁裁决',
  '申请认可和执行台湾地区法院民事判决',
  '申请认可和执行台湾地区仲裁裁决',
  '申请承认和执行外国法院民事判决、裁定',
  '申请承认和执行外国仲裁裁决',

  // ==================== 特殊诉讼程序案件案由 ====================
  '特殊诉讼程序案件案由',
  '与宣告失踪、宣告死亡案件有关的纠纷',
  '失踪人债务支付纠纷',
  '被撤销死亡宣告人请求返还财产纠纷',
  '公益诉讼',
  '生态环境保护民事公益诉讼',
  '环境污染民事公益诉讼',
  '生态破坏民事公益诉讼',
  '生态环境损害赔偿诉讼',
  '英雄烈士保护民事公益诉讼',
  '未成年人保护民事公益诉讼',
  '消费者权益保护民事公益诉讼',
  '第三人撤销之诉',
  '执行程序中的异议之诉',
  '执行异议之诉',
  '案外人执行异议之诉',
  '申请执行人执行异议之诉',
  '追加、变更被执行人异议之诉',
  '执行分配方案异议之诉',

  // ==================== 刑事案由 ====================
  '危害国家安全罪',
  '背叛国家罪',
  '分裂国家罪',
  '煽动分裂国家罪',
  '武装叛乱、暴乱罪',
  '颠覆国家政权罪',
  '煽动颠覆国家政权罪',
  '资助危害国家安全犯罪活动罪',
  '投敌叛变罪',
  '叛逃罪',
  '间谍罪',
  '为境外窃取、刺探、收买、非法提供国家秘密、情报罪',
  '资敌罪',
  '危害公共安全罪',
  '放火罪',
  '决水罪',
  '爆炸罪',
  '投放危险物质罪',
  '以危险方法危害公共安全罪',
  '失火罪',
  '过失决水罪',
  '过失爆炸罪',
  '过失投放危险物质罪',
  '过失以危险方法危害公共安全罪',
  '破坏交通工具罪',
  '破坏交通设施罪',
  '破坏电力设备罪',
  '破坏易燃易爆设备罪',
  '过失损坏交通工具罪',
  '过失损坏交通设施罪',
  '过失损坏电力设备罪',
  '过失损坏易燃易爆设备罪',
  '组织、领导、参加恐怖组织罪',
  '帮助恐怖活动罪',
  '劫持航空器罪',
  '劫持船只、汽车罪',
  '暴力危及飞行安全罪',
  '破坏广播电视设施、公用电信设施罪',
  '过失损坏广播电视设施、公用电信设施罪',
  '非法制造、买卖、运输、邮寄、储存枪支、弹药、爆炸物罪',
  '非法制造、买卖、运输、储存危险物质罪',
  '违规制造、销售枪支罪',
  '盗窃、抢夺枪支、弹药、爆炸物、危险物质罪',
  '抢劫枪支、弹药、爆炸物、危险物质罪',
  '非法持有、私藏枪支、弹药罪',
  '非法出租、出借枪支罪',
  '丢失枪支不报罪',
  '非法携带枪支、弹药、管制刀具、危险物品危及公共安全罪',
  '重大飞行事故罪',
  '铁路运营安全事故罪',
  '交通肇事罪',
  '妨害安全驾驶罪',
  '危险驾驶罪',
  '重大责任事故罪',
  '危险作业罪',
  '重大劳动安全事故罪',
  '危险物品肇事罪',
  '工程重大安全事故罪',
  '教育设施重大安全事故罪',
  '消防责任事故罪',
  '强令、组织他人违章冒险作业罪',
  '大型群众性活动重大安全事故罪',
  '不报、谎报安全事故罪',
  '准备实施恐怖活动罪',
  '宣扬恐怖主义、极端主义、煽动实施恐怖活动罪',
  '利用极端主义破坏法律实施罪',
  '强制穿戴宣扬恐怖主义、极端主义服饰、标志罪',
  '非法持有宣扬恐怖主义、极端主义物品罪',
  '破坏社会主义市场经济秩序罪',
  '生产、销售伪劣商品罪',
  '生产、销售伪劣产品罪',
  '生产、销售、提供假药罪',
  '生产、销售、提供劣药罪',
  '妨害药品管理罪',
  '生产、销售不符合安全标准的食品罪',
  '生产、销售有毒、有害食品罪',
  '生产、销售不符合标准的医用器材罪',
  '生产、销售不符合安全标准的产品罪',
  '生产、销售伪劣农药、兽药、化肥、种子罪',
  '生产、销售不符合卫生标准的化妆品罪',
  '走私罪',
  '走私武器、弹药罪',
  '走私核材料罪',
  '走私假币罪',
  '走私文物罪',
  '走私贵重金属罪',
  '走私珍贵动物、珍贵动物制品罪',
  '走私珍稀植物、珍稀植物制品罪',
  '走私淫秽物品罪',
  '走私普通货物、物品罪',
  '走私废物罪',
  '走私国家禁止进出口的货物、物品罪',
  '妨害对公司、企业的管理秩序罪',
  '虚报注册资本罪',
  '虚假出资、抽逃出资罪',
  '欺诈发行证券罪',
  '妨害清算罪',
  '隐匿、故意销毁会计凭证、会计账簿、财务会计报告罪',
  '对非国家工作人员行贿罪',
  '非法经营同类营业罪',
  '为亲友非法牟利罪',
  '签订、履行合同失职被骗罪',
  '国有公司、企业、事业单位人员失职罪',
  '国有公司、企业、事业单位人员滥用职权罪',
  '徇私舞弊低价折股、出售国有资产罪',
  '违规披露、不披露重要信息罪',
  '虚假破产罪',
  '非国家工作人员受贿罪',
  '背信损害上市公司利益罪',
  '对外国公职人员、国际公共组织官员行贿罪',
  '破坏金融管理秩序罪',
  '伪造货币罪',
  '出售、购买、运输假币罪',
  '金融工作人员购买假币、以假币换取货币罪',
  '持有、使用假币罪',
  '变造货币罪',
  '擅自设立金融机构罪',
  '伪造、变造、转让金融机构经营许可证、批准文件罪',
  '高利转贷罪',
  '非法吸收公众存款罪',
  '伪造、变造金融票证罪',
  '伪造、变造国家有价证券罪',
  '伪造、变造股票、公司、企业债券罪',
  '擅自发行股票、公司、企业债券罪',
  '内幕交易、泄露内幕信息罪',
  '编造并传播证券、期货交易虚假信息罪',
  '诱骗投资者买卖证券、期货合约罪',
  '操纵证券、期货市场罪',
  '骗购外汇罪',
  '违法发放贷款罪',
  '用帐外客户资金非法拆借、发放贷款罪',
  '对违法票据承兑、付款、保证罪',
  '逃汇罪',
  '洗钱罪',
  '骗取贷款、票据承兑、金融票证罪',
  '妨害信用卡管理罪',
  '窃取、收买、非法提供信用卡信息罪',
  '背信运用受托财产罪',
  '违法运用资金罪',
  '吸收客户资金不入账罪',
  '违规出具金融票证罪',
  '利用未公开信息交易罪',
  '金融诈骗罪',
  '集资诈骗罪',
  '贷款诈骗罪',
  '票据诈骗罪',
  '金融凭证诈骗罪',
  '信用证诈骗罪',
  '信用卡诈骗罪',
  '有价证券诈骗罪',
  '保险诈骗罪',
  '危害税收征管罪',
  '抗税罪',
  '逃避追缴欠税罪',
  '骗取出口退税罪',
  '虚开增值税专用发票、用于骗取出口退税、抵扣税款发票罪',
  '伪造、出售伪造的增值税专用发票罪',
  '非法出售增值税专用发票罪',
  '非法购买增值税专用发票、购买伪造的增值税专用发票罪',
  '非法制造、出售非法制造的发票罪',
  '非法出售用于骗取出口退税、抵扣税款发票罪',
  '非法出售发票罪',
  '逃税罪',
  '虚开发票罪',
  '持有伪造的发票罪',
  '非法制造、出售非法制造的用于骗取出口退税、抵扣税款发票罪',
  '侵犯知识产权罪',
  '假冒注册商标罪',
  '销售假冒注册商标的商品罪',
  '非法制造、销售非法制造的注册商标标识罪',
  '假冒专利罪',
  '侵犯著作权罪',
  '销售侵权复制品罪',
  '侵犯商业秘密罪',
  '为境外窃取、刺探、收买、非法提供商业秘密罪',
  '扰乱市场秩序罪',
  '损害商业信誉、商品声誉罪',
  '虚假广告罪',
  '串通投标罪',
  '合同诈骗罪',
  '非法经营罪',
  '强迫交易罪',
  '伪造、倒卖伪造的有价票证罪',
  '倒卖车票、船票罪',
  '非法转让、倒卖土地使用权罪',
  '提供虚假证明文件罪',
  '出具证明文件重大失实罪',
  '逃避商检罪',
  '组织、领导传销活动罪',
  '侵犯公民人身权利、民主权利罪',
  '故意杀人罪',
  '过失致人死亡罪',
  '故意伤害罪',
  '过失致人重伤罪',
  '强奸罪',
  '负有照护职责人员性侵罪',
  '猥亵儿童罪',
  '非法拘禁罪',
  '绑架罪',
  '拐卖妇女、儿童罪',
  '收买被拐卖的妇女、儿童罪',
  '聚众阻碍解救被收买的妇女、儿童罪',
  '诬告陷害罪',
  '强迫劳动罪',
  '雇用童工从事危重劳动罪',
  '非法搜查罪',
  '非法侵入住宅罪',
  '侮辱罪',
  '诽谤罪',
  '刑讯逼供罪',
  '暴力取证罪',
  '虐待被监管人罪',
  '煽动民族仇恨、民族歧视罪',
  '出版歧视、侮辱少数民族作品罪',
  '非法剥夺公民宗教信仰自由罪',
  '侵犯少数民族风俗习惯罪',
  '侵犯通信自由罪',
  '私自开拆、隐匿、毁弃邮件、电报罪',
  '报复陷害罪',
  '打击报复会计、统计人员罪',
  '破坏选举罪',
  '暴力干涉婚姻自由罪',
  '重婚罪',
  '破坏军婚罪',
  '虐待罪',
  '遗弃罪',
  '拐骗儿童罪',
  '组织残疾人、儿童乞讨罪',
  '组织未成年人进行违反治安管理活动罪',
  '组织出卖人体器官罪',
  '强制猥亵、侮辱罪',
  '侵犯公民个人信息罪',
  '虐待被监护、看护人罪',
  '侵犯财产罪',
  '抢劫罪',
  '盗窃罪',
  '诈骗罪',
  '抢夺罪',
  '聚众哄抢罪',
  '侵占罪',
  '职务侵占罪',
  '挪用资金罪',
  '挪用特定款物罪',
  '敲诈勒索罪',
  '故意毁坏财物罪',
  '破坏生产经营罪',
  '拒不支付劳动报酬罪',
  '妨害社会管理秩序罪',
  '扰乱公共秩序罪',
  '妨害公务罪',
  '袭警罪',
  '煽动暴力抗拒法律实施罪',
  '招摇撞骗罪',
  '伪造、变造、买卖国家机关公文、证件、印章罪',
  '盗窃、抢夺、毁灭国家机关公文、证件、印章罪',
  '伪造公司、企业、事业单位、人民团体印章罪',
  '非法生产、买卖警用装备罪',
  '非法获取国家秘密罪',
  '非法持有国家绝密、机密文件、资料、物品罪',
  '非法使用窃听、窃照专用器材罪',
  '非法侵入计算机信息系统罪',
  '破坏计算机信息系统罪',
  '扰乱无线电通讯管理秩序罪',
  '聚众扰乱社会秩序罪',
  '聚众冲击国家机关罪',
  '聚众扰乱公共场所秩序、交通秩序罪',
  '投放虚假危险物质罪',
  '高空抛物罪',
  '聚众斗殴罪',
  '寻衅滋事罪',
  '催收非法债务罪',
  '组织、领导、参加黑社会性质组织罪',
  '入境发展黑社会组织罪',
  '包庇、纵容黑社会性质组织罪',
  '传授犯罪方法罪',
  '非法集会、游行、示威罪',
  '破坏集会、游行、示威罪',
  '侮辱国旗、国徽罪',
  '侵害英雄烈士名誉、荣誉罪',
  '组织、利用会道门、邪教组织、利用迷信破坏法律实施罪',
  '组织、利用会道门、邪教组织利用迷信致人重伤、死亡罪',
  '聚众淫乱罪',
  '引诱未成年人聚众淫乱罪',
  '盗窃、侮辱、故意毁坏尸体、尸骨、骨灰罪',
  '赌博罪',
  '组织参与国（境）外赌博罪',
  '故意延误投递邮件罪',
  '编造、故意传播虚假恐怖信息罪',
  '开设赌场罪',
  '非法获取计算机信息系统数据、非法控制计算机信息系统罪',
  '提供侵入、非法控制计算机信息系统程序、工具罪',
  '使用虚假身份证件、盗用身份证件罪',
  '冒名顶替罪',
  '非法生产、销售专用间谍器材、窃听、窃照专用器材罪',
  '组织考试作弊罪',
  '非法出售、提供试题、答案罪',
  '代替考试罪',
  '拒不履行信息网络安全管理义务罪',
  '非法利用信息网络罪',
  '帮助信息网络犯罪活动罪',
  '扰乱国家机关工作秩序罪',
  '组织、资助非法聚集罪',
  '编造、故意传播虚假信息罪',
  '非法携带武器、管制刀具、爆炸物参加集会、游行、示威罪',
  '妨害司法罪',
  '伪证罪',
  '辩护人、诉讼代理人毁灭证据、伪造证据、妨害作证罪',
  '妨害作证罪',
  '帮助毁灭、伪造证据罪',
  '打击报复证人罪',
  '扰乱法庭秩序罪',
  '窝藏、包庇罪',
  '拒不执行判决、裁定罪',
  '非法处置查封、扣押、冻结的财产罪',
  '破坏监管秩序罪',
  '脱逃罪',
  '劫夺被押解人员罪',
  '组织越狱罪',
  '暴动越狱罪',
  '聚众持械劫狱罪',
  '掩饰、隐瞒犯罪所得、犯罪所得收益罪',
  '虚假诉讼罪',
  '泄露不应公开的案件信息罪',
  '披露、报道不应公开的案件信息罪',
  '拒绝提供间谍犯罪、恐怖主义犯罪、极端主义犯罪证据罪',
  '妨害国（边）境管理罪',
  '组织他人偷越国（边）境罪',
  '骗取出境证件罪',
  '提供伪造、变造的出入境证件罪',
  '出售出入境证件罪',
  '运送他人偷越国（边）境罪',
  '偷越国（边）境罪',
  '破坏界碑、界桩罪',
  '破坏永久性测量标志罪',
  '妨害文物管理罪',
  '故意损毁文物罪',
  '故意损毁名胜古迹罪',
  '过失损毁文物罪',
  '非法向外国人出售、赠送珍贵文物罪',
  '倒卖文物罪',
  '非法出售、私赠文物藏品罪',
  '盗掘古文化遗址、古墓葬罪',
  '盗掘古人类化石、古脊椎动物化石罪',
  '抢夺、窃取国有档案罪',
  '擅自出卖、转让国有档案罪',
  '危害公共卫生罪',
  '妨害传染病防治罪',
  '传染病菌种、毒种扩散罪',
  '妨害国境卫生检疫罪',
  '非法组织卖血罪',
  '强迫卖血罪',
  '非法采集、供应血液、制作、供应血液制品罪',
  '采集、供应血液、制作、供应血液制品事故罪',
  '非法采集人类遗传资源、走私人类遗传资源材料罪',
  '医疗事故罪',
  '非法行医罪',
  '非法进行节育手术罪',
  '非法植入基因编辑、克隆胚胎罪',
  '妨害动植物防疫、检疫罪',
  '破坏环境资源保护罪',
  '污染环境罪',
  '非法处置进口的固体废物罪',
  '擅自进口固体废物罪',
  '非法捕捞水产品罪',
  '危害珍贵、濒危野生动物罪',
  '非法猎捕、杀害珍贵、濒危野生动物罪',
  '非法收购、运输、出售珍贵、濒危野生动物、珍贵、濒危野生动物制品罪',
  '非法狩猎罪',
  '非法猎捕、收购、运输、出售陆生野生动物罪',
  '非法占用农用地罪',
  '破坏自然保护地罪',
  '非法采矿罪',
  '破坏性采矿罪',
  '危害国家重点保护植物罪',
  '非法采伐、毁坏国家重点保护植物罪',
  '非法引进、释放、丢弃外来入侵物种罪',
  '非法收购、运输、加工、出售国家重点保护植物、国家重点保护植物制品罪',
  '盗伐林木罪',
  '滥伐林木罪',
  '非法收购、运输盗伐、滥伐的林木罪',
  '走私、贩卖、运输、制造毒品罪',
  '非法持有毒品罪',
  '包庇毒品犯罪分子罪',
  '窝藏、转移、隐瞒毒品、毒赃罪',
  '非法种植毒品原植物罪',
  '非法买卖、运输、携带、持有毒品原植物种子、幼苗罪',
  '引诱、教唆、欺骗他人吸毒罪',
  '强迫他人吸毒罪',
  '容留他人吸毒罪',
  '非法提供麻醉药品、精神药品罪',
  '妨害兴奋剂管理罪',
  '非法生产、买卖、运输制毒物品、走私制毒物品罪',
  '组织、强迫、引诱、容留、介绍卖淫罪',
  '组织卖淫罪',
  '强迫卖淫罪',
  '协助组织卖淫罪',
  '引诱、容留、介绍卖淫罪',
  '引诱幼女卖淫罪',
  '传播性病罪',
  '制作、贩卖、传播淫秽物品罪',
  '制作、复制、出版、贩卖、传播淫秽物品牟利罪',
  '为他人提供书号出版淫秽书刊罪',
  '传播淫秽物品罪',
  '组织播放淫秽音像制品罪',
  '组织淫秽表演罪',
  '危害国防利益罪',
  '阻碍军人执行职务罪',
  '阻碍军事行动罪',
  '破坏武器装备、军事设施、军事通信罪',
  '故意提供不合格武器装备、军事设施罪',
  '过失提供不合格武器装备、军事设施罪',
  '聚众冲击军事禁区罪',
  '聚众扰乱军事管理区秩序罪',
  '冒充军人招摇撞骗罪',
  '煽动军人逃离部队罪',
  '雇用逃离部队军人罪',
  '接送不合格兵员罪',
  '伪造、变造、买卖武装部队公文、证件、印章罪',
  '盗窃、抢夺武装部队公文、证件、印章罪',
  '战时拒绝、逃避征召、军事训练罪',
  '战时拒绝、逃避服役罪',
  '战时故意提供虚假敌情罪',
  '战时造谣扰乱军心罪',
  '战时窝藏逃离部队军人罪',
  '战时拒绝、故意延误军事订货罪',
  '战时拒绝军事征收、征用罪',
  '过失损坏武器装备、军事设施、军事通信罪',
  '非法生产、买卖武装部队制式服装罪',
  '伪造、盗窃、买卖、非法提供、非法使用武装部队专用标志罪',
  '贪污贿赂罪',
  '贪污罪',
  '挪用公款罪',
  '受贿罪',
  '单位受贿罪',
  '行贿罪',
  '对单位行贿罪',
  '介绍贿赂罪',
  '单位行贿罪',
  '巨额财产来源不明罪',
  '隐瞒境外存款罪',
  '私分国有资产罪',
  '私分罚没财物罪',
  '利用影响力受贿罪',
  '对有影响力的人行贿罪',
  '渎职罪',
  '滥用职权罪',
  '玩忽职守罪',
  '故意泄露国家秘密罪',
  '过失泄露国家秘密罪',
  '徇私枉法罪',
  '民事、行政枉法裁判罪',
  '执行判决、裁定失职罪',
  '执行判决、裁定滥用职权罪',
  '私放在押人员罪',
  '失职致使在押人员脱逃罪',
  '徇私舞弊减刑、假释、暂予监外执行罪',
  '徇私舞弊不移交刑事案件罪',
  '滥用管理公司、证券职权罪',
  '徇私舞弊不征、少征税款罪',
  '徇私舞弊发售发票、抵扣税款、出口退税罪',
  '违法提供出口退税凭证罪',
  '国家机关工作人员签订、履行合同失职被骗罪',
  '违法发放林木采伐许可证罪',
  '环境监管失职罪',
  '传染病防治失职罪',
  '非法低价出让国有土地使用权罪',
  '放纵走私罪',
  '商检徇私舞弊罪',
  '商检失职罪',
  '动植物检疫徇私舞弊罪',
  '动植物检疫失职罪',
  '放纵制售伪劣商品犯罪行为罪',
  '办理偷越国（边）境人员出入境证件罪',
  '放行偷越国（边）境人员罪',
  '不解救被拐卖、绑架妇女、儿童罪',
  '阻碍解救被拐卖、绑架妇女、儿童罪',
  '帮助犯罪分子逃避处罚罪',
  '招收公务员、学生徇私舞弊罪',
  '失职造成珍贵文物损毁、流失罪',
  '枉法仲裁罪',
  '食品、药品监管渎职罪',
  '非法批准征收、征用、占用土地罪',
  '军人违反职责罪',
  '战时违抗命令罪',
  '隐瞒、谎报军情罪',
  '拒传、假传军令罪',
  '投降罪',
  '战时临阵脱逃罪',
  '擅离、玩忽军事职守罪',
  '阻碍执行军事职务罪',
  '指使部属违反职责罪',
  '违令作战消极罪',
  '拒不救援友邻部队罪',
  '军人叛逃罪',
  '非法获取军事秘密罪',
  '为境外窃取、刺探、收买、非法提供军事秘密罪',
  '故意泄露军事秘密罪',
  '过失泄露军事秘密罪',
  '战时造谣惑众罪',
  '战时自伤罪',
  '逃离部队罪',
  '武器装备肇事罪',
  '擅自改变武器装备编配用途罪',
  '盗窃、抢夺武器装备、军用物资罪',
  '非法出卖、转让武器装备罪',
  '遗弃武器装备罪',
  '遗失武器装备罪',
  '擅自出卖、转让军队房地产罪',
  '虐待部属罪',
  '遗弃伤病军人罪',
  '战时拒不救治伤病军人罪',
  '战时残害居民、掠夺居民财物罪',
  '私放俘虏罪',
  '虐待俘虏罪',

  // ==================== 行政案由 ====================
  '行政行为',
  '历史行政行为',
  '行政强制',
  '行政批准',
  '行政命令',
  '行政撤销',
  '行政检查',
  '行政合同',
  '行政执行',
  '行政受理',
  '行政征用',
  '行政征购',
  '行政征收',
  '行政划拔',
  '行政规划',
  '行政救助',
  '行政协助',
  '行政监督',
  '其他行政行为',
  '行政处罚',
  '警告',
  '通报批评',
  '罚款',
  '没收违法所得',
  '没收非法财物',
  '暂扣许可证件',
  '吊销许可证件',
  '降低资质等级',
  '责令关闭',
  '责令停产停业',
  '限制开展生产经营活动',
  '限制从业',
  '行政拘留',
  '不得申请行政许可',
  '责令限期拆除',
  '行政强制措施',
  '限制人身自由',
  '查封场所、设施或者财物',
  '扣押财物',
  '冻结存款、汇款',
  '冻结资金、证券',
  '强制隔离戒毒',
  '留置',
  '采取保护性约束措施',
  '行政强制执行',
  '加处罚款或者滞纳金',
  '划拨存款、汇款',
  '拍卖查封、扣押的场所、设施或者财物',
  '处理查封、扣押的场所、设施或者财物',
  '排除妨碍',
  '恢复原状',
  '代履行',
  '强制拆除房屋或者设施',
  '强制清除地上物',
  '行政许可',
  '工商登记',
  '社会团体登记',
  '颁发机动车驾驶证',
  '特许经营许可',
  '建设工程规划许可',
  '建筑工程施工许可',
  '矿产资源许可',
  '药品注册许可',
  '医疗器械许可',
  '执业资格许可',
  '行政征收或者征用',
  '征收或者征用房屋',
  '征收或者征用土地',
  '征收或者征用动产',
  '行政登记',
  '房屋所有权登记',
  '集体土地所有权登记',
  '森林、林木所有权登记',
  '矿业权登记',
  '土地承包经营权登记',
  '建设用地使用权登记',
  '宅基地使用权登记',
  '海域使用权登记',
  '水利工程登记',
  '居住权登记',
  '地役权登记',
  '不动产抵押登记',
  '动产抵押登记',
  '质押登记',
  '机动车所有权登记',
  '船舶所有权登记',
  '户籍登记',
  '婚姻登记',
  '收养登记',
  '税务登记',
  '行政确认',
  '基本养老保险资格或者待遇认定',
  '基本医疗保险资格或者待遇认定',
  '失业保险资格或者待遇认定',
  '工伤保险资格或者待遇认定',
  '生育保险资格或者待遇认定',
  '最低生活保障资格或者待遇认定',
  '确认保障性住房分配资格',
  '颁发学位证书或者毕业证书',
  '行政给付',
  '给付抚恤金',
  '给付基本养老金',
  '给付基本医疗保险金',
  '给付失业保险金',
  '给付工伤保险金',
  '给付生育保险金',
  '给付最低生活保障金',
  '行政允诺',
  '兑现奖金',
  '兑现优惠',
  '行政征缴',
  '征缴税款',
  '征缴社会抚养费',
  '征缴社会保险费',
  '征缴污水处理费',
  '征缴防空地下室易地建设费',
  '征缴水土保持补偿费',
  '征缴土地闲置费',
  '征缴土地复垦费',
  '征缴耕地开垦费',
  '行政奖励',
  '授予荣誉称号',
  '发放奖金',
  '行政收费',
  '证照费',
  '车辆通行费',
  '企业注册登记费',
  '不动产登记费',
  '船舶登记费',
  '考试考务费',
  '政府信息公开',
  '行政批复',
  '行政处理',
  '责令退还非法占用土地',
  '责令交还土地',
  '责令改正',
  '责令采取补救措施',
  '责令停止建设',
  '责令恢复原状',
  '责令公开',
  '责令召回',
  '责令暂停生产',
  '责令暂停销售',
  '责令暂停使用',
  '有偿收回国有土地使用权',
  '退学决定',
  '行政复议',
  '不予受理行政复议申请决定',
  '驳回行政复议申请决定',
  'xx（行政行为）及行政复议',
  '改变原行政行为的行政复议决定',
  '行政裁决',
  '土地、矿藏、水流、荒地或者滩涂权属确权',
  '林地、林木、山岭权属确权',
  '海域使用权确权',
  '草原权属确权',
  '水利工程权属确权',
  '企业资产性质确认',
  '行政协议',
  '订立xx（行政协议）',
  '单方变更xx（行政协议）',
  '单方解除xx（行政协议）',
  '不依法履行xx（行政协议）',
  '未按约定履行xx（行政协议）',
  'xx（行政协议）',
  'xx（行政协议）行政补偿',
  'xx（行政协议）行政赔偿',
  '撤销xx（行政协议）',
  '解除xx（行政协议）',
  '继续履行xx（行政协议）',
  '确认xx（行政协议）无效或有效',
  '行政补偿',
  '行政补偿',
  '房屋征收或者征用补偿',
  '土地征收或者征用补偿',
  '动产征收或者征用补偿',
  '撤回行政许可补偿',
  '收回国有土地使用权补偿',
  '规划变更补偿',
  '移民安置补偿',
  '行政赔偿',
  '不履行xx职责',
  'xx（行政行为）',
  '公益诉讼',
  '未列举被诉行政行为',
  '行政不作为',

  // ==================== 行政管理范围 ====================
  '行政管理范围',
  '公安行政管理',
  '治安管理(治安)',
  '消防管理(消防)',
  '道路交通管理(道路)',
  '其他(公安)',
  '资源行政管理',
  '土地行政管理(土地)',
  '林业行政管理(林业)',
  '草原行政管理(草原)',
  '地质矿产行政管理(地矿)',
  '能源行政管理(能源管理)',
  '其他(资源)',
  '城乡建设行政管理',
  '城市规划管理(规划)',
  '房屋拆迁管理(拆迁)',
  '房屋登记管理(房屋登记)',
  '其他(城建)',
  '计划生育行政管理(计划生育)',
  '工商行政管理(工商)',
  '商标行政管理(商标)',
  '质量监督检验检疫行政管理',
  '质量监督行政管理(质量监督)',
  '质量检验行政管理(质量检验)',
  '检疫行政管理(检疫)',
  '其他(质量监督)',
  '卫生行政管理(卫生)',
  '食品药品安全行政管理(食品、药品)',
  '农业行政管理(农业)',
  '渔业行政管理(渔业)',
  '畜牧行政管理(畜牧)',
  '其他(农业)',
  '植物新品种申请驳回复审行政纠纷',
  '植物新品种权无效行政纠纷',
  '植物新品种权更名行政纠纷',
  '植物新品种权强制许可行政纠纷',
  '植物新品种权实施植物新品种强制许可使用费纠纷',
  '植物新品种权行政复议',
  '植物新品种权行政裁决',
  '植物新品种权行政处理',
  '植物新品种权行政处罚',
  '植物新品种权行政赔偿',
  '植物新品种权其他行政行为',
  '物价行政管理(物价)',
  '环境保护行政管理(环保)',
  '交通运输行政管理(交通)',
  '公路交通行政管理(公路)',
  '铁路行政管理(铁路)',
  '航空行政管理(航空)',
  '其他(交通)',
  '信息电讯行政管理(信息、电讯)',
  '邮政行政管理(邮政)',
  '专利行政管理(专利)',
  '发明专利申请驳回复审行政纠纷',
  '实用新型专利申请驳回复审行政纠纷',
  '外观设计专利申请驳回复审行政纠纷',
  '发明专利权无效行政纠纷',
  '实用新型专利权无效行政纠纷',
  '外观设计专利权无效行政纠纷',
  '发明专利权强制许可行政纠纷',
  '实用新型专利权强制许可行政纠纷',
  '专利行政复议',
  '专利行政裁决',
  '专利行政处理',
  '专利行政处罚',
  '专利行政赔偿',
  '专利其他行政行为',
  '新闻出版行政管理(新闻、出版)',
  '税务行政管理(税务)',
  '金融行政管理(金融)',
  '外汇行政管理(外汇)',
  '海关行政管理(海关)',
  '财政行政管理(财政)',
  '劳动和社会保障行政管理(劳动、社会保障)',
  '审计行政管理(审计)',
  '经贸行政管理(内贸、外贸)',
  '水利行政管理(水利)',
  '旅游行政管理(旅游)',
  '烟草专卖行政管理(烟草专卖)',
  '司法行政管理(司法行政)',
  '民政行政管理(民政)',
  '教育行政管理(教育)',
  '文化行政管理(文化)',
  '广播电视电影行政管理(广电)',
  '统计行政管理(统计)',
  '电力行政管理(电力)',
  '国有资产行政管理(国资)',
  '外资行政管理(外资管理)',
  '盐业行政管理(盐业)',
  '体育行政管理(体育)',
  '行政监察(监察)',
  '乡政府其他行政管理',
  '集成电路布图设计申请驳回复审行政纠纷',
  '集成电路布图设计专有权撤销行政纠纷',
  '使用集成电路布图设计非自愿许可行政纠纷',
  '使用集成电路布图设计非自愿许可报酬行政纠纷',
  '集成电路布图设计行政复议',
  '集成电路布图设计行政裁决',
  '集成电路布图设计行政处理',
  '集成电路布图设计行政处罚',
  '集成电路布图设计行政赔偿',
  '集成电路布图设计其他行政纠纷',
  '滥用行政权力排除、限制竞争',
  '反垄断行政复议',
  '反垄断行政裁决',
  '反垄断行政处理',
  '反垄断行政处罚',
  '反垄断行政赔偿',
  '反垄断其他行政行为',

  // ==================== 司法赔偿 ====================
  '司法赔偿',
  '违法刑事拘留赔偿',
  '无罪逮捕赔偿',
  '二审无罪赔偿',
  '重审无罪赔偿',
  '再审无罪赔偿',
  '刑讯逼供致伤、致死赔偿',
  '殴打、虐待致伤、致死赔偿',
  '违法使用武器、警械致伤、致死赔偿',
  '刑事违法查封、扣押、冻结、追缴赔偿',
  '错判罚金、没收财产赔偿',
  '违法司法罚款赔偿',
  '违法司法拘留赔偿',
  '违法保全赔偿',
  '错误执行赔偿',

  // ==================== 历史案由 ====================
  '历史案由',
  '人民调解协议纠纷',
  '请求履行人民调解协议纠纷',
  '请求变更人民调解协议纠纷',
  '请求撤销人民调解协议纠纷',
  '请求确认人民调解协议无效纠纷',
  '特殊类型的侵权纠纷',
  '产品质量损害赔偿纠纷',
  '高度危险作业损害赔偿纠纷',
  '环境污染侵权纠纷',
  '大气污染侵权纠纷',
  '水污染侵权纠纷',
  '噪声污染侵权纠纷',
  '放射性污染侵权纠纷',
  '地面、公共场所施工损害赔偿纠纷',
  '建筑物、搁置物、悬挂物塌落损害赔偿纠纷',
  '饲养动物致人损害赔偿纠纷',
  '国家机关及其工作人员职务侵权纠纷',
  '雇员受害赔偿纠纷',
  '雇主损害赔偿纠纷',
  '驻香港、澳门特别行政区军人执行职务侵权纠纷',
  '防卫过当损害赔偿纠纷',
  '紧急避险损害赔偿纠纷',
  '公证损害赔偿纠纷',
  '义务帮工人受害赔偿、补偿纠纷',
  '见义勇为人受害赔偿、补偿纠纷',
  '多式联运合同纠纷（由海事法院受理的）',
  '与铁路运输有关的民事纠纷',
  '铁路旅客、行李、包裹运输合同纠纷',
  '多式联运合同纠纷（由铁路法院受理的）',
  '铁路货物、旅客、行李、包裹运输保险合同纠纷',
  '铁路运输延伸服务合同纠纷',
  '铁路修建、管理和运输合同纠纷',
  '铁路委外劳务合同纠纷',
  '损害铁路赔偿纠纷',
  '铁路运输人身、财产损害赔偿纠纷',
  '铁路电信服务合同纠纷',
  '公司章程或章程条款撤销纠纷',
  '普通合伙纠纷',
  '特殊的普通合伙纠纷',
  '有限合伙纠纷',
  '职工权益清单更正纠纷',
  '担保追偿权纠纷',
  '海上保险、保赔合同纠纷',
  '股东名册变更纠纷',
  '股份收购请求权纠纷',
  '股东会或者股东大会、董事会决议效力纠纷',
  '股东会或者股东大会、董事会决议效力确认纠纷',
  '股东会或者股东大会、董事会决议撤销纠纷',
  '股东滥用股东权利赔偿纠纷',
  '股东滥用公司法人独立地位和股东有限责任赔偿纠纷',
  '董事、高级管理人员损害股东利益赔偿纠纷',
  '公司的控股股东、实际控制人、董事、监事、高级管理人员损害公司利益赔偿纠纷',
  '清算组成员责任纠纷',
  '公司清算纠纷',
  '期货欺诈赔偿纠纷',
  '操纵期货交易市场赔偿纠纷',
  '期货内幕交易赔偿纠纷',
  '期货虚假信息赔偿纠纷',
  '机动车交通事故责任强制保险合同纠纷',
  '保险代位求偿权纠纷',
  '申请海事债权确权',
  '按份共有纠纷',
  '共同共有纠纷',
  '承租人优先购买权纠纷',
  '侵犯著作人身权纠纷',
  '侵犯著作财产权纠纷',
  '邻接权权属纠纷',
  '侵犯奥林匹克标志专有权纠纷',
  '侵犯世界博览会标志专有权纠纷',
  '集体劳动合同纠纷',
  '养老金纠纷',
  '医疗费、医疗保险待遇纠纷',
  '证券衍生品种交易纠纷',
  '请求确认人民调解协议效力',
  '因申请诉中财产保全损害责任纠纷',
  '因申请诉中证据保全损害责任纠纷',
  '申请诉中财产保全',
  '申请诉中证据保全',
  '电视购物合同纠纷',
  '企业借贷纠纷',
  '土地承包经营权转包合同纠纷',
  '伪造、冒用产品质量标志纠纷',
  '伪造产地纠纷',
  '道路交通事故人身损害赔偿纠纷',
  '医疗损害赔偿纠纷',
  '工伤事故损害赔偿纠纷',
  '水上运输人身损害赔偿纠纷',
  '航空运输人身损害赔偿纠纷',
  '航空器对地、水面上第三人损害赔偿纠纷',
  '触电人身损害赔偿纠纷',
  '计算机网络域名权属、侵权纠纷',
  '计算机网络域名权属纠纷',
  '侵犯计算机网络域名纠纷',
  '确认不侵权纠纷',
  '因申请临时措施损害赔偿纠纷',
  '海上财产损害赔偿纠纷',
  '海上人身损害赔偿纠纷',
  '劳务（雇佣）合同纠纷',
  '其他民事纠纷',
  '嫖宿幼女罪（已取消）',
  '中外合作勘探开发自然资源合同纠纷',
  '排污权交易纠纷',
  '用能权交易纠纷',
  '用水权交易纠纷',
  '碳排放权交易纠纷',
  '碳汇交易纠纷',

  // ==================== 其他 ====================
  '其他',
];
